import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './CandidateTile.scss';
import { ReactComponent as ArrowIcon } from 'assets/icons/redesign/arrow-right-up.svg';

export interface CandidateTileData {
    id: number;
    firstName: string;
    lastName: string;
    picture: string;
    facultyShort?: string;
    course?: number;
    groupName?: string;
}

interface CandidateTileProps {
    data: CandidateTileData;
    electionId?: number;
    preview?: boolean;
}
function CandidateTile({
    data,
    electionId,
    preview,
}: CandidateTileProps): React.ReactElement {
    const { search } = useLocation();
    const subtitle =
        data.facultyShort && data.groupName
            ? `${data.facultyShort} | ${data.course} курс | ${data.groupName}`
            : undefined;

    const card = (
        <div className="rd-tile__card">
            <span
                className="rd-tile__photo"
                style={{ backgroundImage: `url(${data.picture})` }}
            >
                {!preview && (
                    <span className="rd-tile__arrow" aria-hidden="true">
                        <ArrowIcon />
                    </span>
                )}
            </span>
            <span className="rd-tile__name">
                {data.firstName} {data.lastName}
            </span>
            {subtitle ? <span className="rd-tile__sub">{subtitle}</span> : null}
            {!preview && (
                <span className="rd-tile__program">
                    О кандидате и программа
                </span>
            )}
        </div>
    );

    if (preview) {
        return (
            <div
                className="rd-tile rd-tile--preview"
                aria-label={`${data.firstName} ${data.lastName}`}
            >
                {card}
            </div>
        );
    }

    return (
        <Link
            className="rd-tile"
            to={`/elections/${electionId}/candidates/${data.id}${search}`}
            aria-label={`${data.firstName} ${data.lastName}`}
        >
            {card}
        </Link>
    );
}

CandidateTile.defaultProps = {
    electionId: undefined,
    preview: false,
};

export default React.memo(CandidateTile);
